import { render, staticRenderFns } from "./lab_area_sel_task.vue?vue&type=template&id=34a47216&scoped=true"
import script from "./lab_area_sel_task.vue?vue&type=script&lang=js"
export * from "./lab_area_sel_task.vue?vue&type=script&lang=js"
import style0 from "./lab_area_sel_task.vue?vue&type=style&index=0&id=34a47216&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a47216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a47216')) {
      api.createRecord('34a47216', component.options)
    } else {
      api.reload('34a47216', component.options)
    }
    module.hot.accept("./lab_area_sel_task.vue?vue&type=template&id=34a47216&scoped=true", function () {
      api.rerender('34a47216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/lab_area_sel_task.vue"
export default component.exports